import getMuiTheme from 'material-ui/styles/getMuiTheme';

export const muiThemeStyle = getMuiTheme({
    palette: {
        primary1Color: 'rgb(255, 186, 0)',
        primary2Color: 'rgb(255, 186, 0)',
        primary3Color: 'rgb(255, 186, 0)',
        pickerHeaderColor: 'rgb(255, 186, 0)',
    },
});
